import { supabase } from "@/shared/lib/supabase";

type ResourceLocator = {
  container: string;
  objectKey: string;
};

export async function openResource(item: ResourceLocator) {
  const resourceWindow = window.open("", "_blank", "noopener,noreferrer");

  const { data, error } = await supabase.storage
    .from(item.container)
    .createSignedUrl(item.objectKey, 60);

  if (error) {
    resourceWindow?.close();
    throw error;
  }

  if (resourceWindow) {
    resourceWindow.location.href = data.signedUrl;
    return;
  }

  window.open(data.signedUrl, "_blank", "noopener,noreferrer");
}
